var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.toCSV()),expression:"toCSV()",arg:"copy"}],attrs:{"outlined":"","color":"orange"}},[_vm._v(" "+_vm._s(_vm.$t("misc.copy"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }